import React from 'react';
import { Link } from 'react-router-dom';
import Processimg01 from '../../../assets/images/process/process-five-1.png';
import Processimg02 from '../../../assets/images/process/process-five-2.png';
import Processimg03 from '../../../assets/images/process/process-five-3.png';

const Process = () => {
    return (
        <>
            <div className="process-section-five">
                <div className="container">
                    <div className="row process-box-outer gutter-y-30">
                        <div className="col-lg-3 col-md-6">
                            <div className="process-box-five one">
                                <div className="process-image-five">
                                    <img
                                        src={Processimg01}
                                        alt="process-image"
                                    />
                                    <span>1</span>
                                </div>
                                <h4>Discussion</h4>
                                <p className="lead">We meet customers in set place to discuss.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="process-box-five two">
                                <div className="process-image-five">
                                    <img
                                        src={Processimg02}
                                        alt="process-image"
                                    />
                                    <span>2</span>
                                </div>
                                <h4>Idea &amp; Concepts</h4>
                                <p className="lead">
                                    Our solutions are scalable and can grow with your business
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="process-box-five three">
                                <div className="process-image-five">
                                    <img
                                        src={Processimg03}
                                        alt="process-image"
                                    />
                                    <span>3</span>
                                </div>
                                <h4>Testing &amp; Trying</h4>
                                <p className="lead">
                                    Our achievements are rooted in fostering deep collaboration.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="process-box-five four">
                                <div className="process-image-five">
                                    <img
                                        src={Processimg01}
                                        alt="process-image"
                                    />
                                    <span>4</span>
                                </div>
                                <h4>Execute &amp; Install</h4>
                                <p className="lead">
                                    We embarked on our journey with a distinct approach.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5 m-auto">
                            <div className="process-info-five">
                                <div className="heading-box light text-center">
                                    <span className="sub-title-two">How does it work?</span>
                                    <h2 className="heading-title">
                                        Successful Financial Control Process
                                    </h2>
                                </div>
                                <Link to="/Pricing" className="btn btn-primary btn-theme">
                                    See&nbsp;Pricing&nbsp;plans <span>+</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Process;
